import type { deploymentEnvironments } from "@shared/env.mjs";
import type z from "zod";

export type Environment = z.infer<typeof deploymentEnvironments>;

export const localEnvironment = new Set<Environment>(["local"]);
export const devEnvironment = new Set<Environment>(["dev"]);
export const productionEnvironment = new Set<Environment>(["prod"]);

export const developmentEnvironments = new Set<Environment>(["dev", "local"]);
